import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
};

export const telecallerReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("GET_ALL_TELECALLERS_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_TELECALLERS_SUCCESS", (state, action) => {
      state.loading = false;
      state.contactsList = action.payload.contactsList;
      state.count = action.payload.count;
    })
    .addCase("GET_ALL_TELECALLERS_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });
});
